import React, { useEffect, useRef, useState } from 'react';
import Hammer from "hammerjs";

import Styles from './style.module.css';

// ✅ 先用旧图片占位（你之后替换成 WithElim 新插图即可）
import TopPic from './WithElimProjectImages/WithElimTopPic.png';
import WithElimLogo from './WithElimProjectImages/WithElimLogo.png';
import WithElimNav from './WithElimProjectImages/Navbar.png';
import WithElimDisplay from './WithElimProjectImages/SiteDisplay.png';
import SiteMap from './WithElimProjectImages/SiteMap.jpeg';
import HiFiPrototype from './WithElimProjectImages/HifiUI.png';
import PrayerCard from './WithElimProjectImages/PrayerCard.png';
import FlutterApp from './WithElimProjectImages/FlutterApp.png';
function WithElimWeb({ SwitcherOnClick }) {
  const [isVisible, setIsVisible] = useState(false);
  const componentRef = useRef(null);

  function getThreshold() {
    const windowWidth = window.innerWidth;
    return windowWidth > 900 ? 0.1 : 0.1;
  }

  useEffect(() => {
    const Switcherobserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setIsVisible(entry.isIntersecting);
        });
      },
      { threshold: getThreshold() }
    );

    const currentElement = componentRef.current;
    if (currentElement) {
      Switcherobserver.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        Switcherobserver.unobserve(currentElement);
      }
    };
  }, []);

  // 检测鼠标滚动
  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    let timeout = null;

    const handleScroll = () => {
      setIsScrolling(true);

      clearTimeout(timeout);

      const delay = window.innerWidth < 900 ? 1000 : 3000;

      timeout = setTimeout(() => {
        setIsScrolling(false);
      }, delay);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timeout);
    };
  }, []);

  const handleScrollToTop = () => {
    const currentElement = componentRef.current;
    if (currentElement) {
      currentElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    if (!componentRef.current) return;

    const hammer = new Hammer(componentRef.current);

    hammer.on("swipeleft", () => {
      handleScrollToTop();
      SwitcherOnClick("left");
    });

    hammer.on("swiperight", () => {
      handleScrollToTop();
      SwitcherOnClick("right");
    });

    return () => {
      hammer.destroy();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id="WithElim" className={Styles.Web} ref={componentRef}>
      <div className={Styles.Content}>
        {/* Hero / Top Image */}
        <img
          src={TopPic}
          alt="WithElim Project"
          width="100%"
          style={{ borderRadius: '2rem', marginBottom: '5vw' }}
        />

        {/* Title + Link */}
        <a style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer" href="https://withelim.com/">
          <h2>WithElim — Bible & Prayer Platform (Web + Mobile)</h2>
        </a>

        <p>
          WithElim is a faith-focused platform designed for <strong>Bible reading</strong>, <strong>verse search</strong>,
          and <strong>prayer journaling</strong>. It helps users link prayers to Scripture and optionally share them with
          the community through simple social features.
          {' '}
          <a target="_blank" rel="noreferrer" href="https://withelim.com/">Visit</a>
        </p>

        <h3>Platforms</h3>
        <ul style={{ textAlign: 'left' }}>
          <li><strong>Web:</strong> responsive layout for desktop and mobile browsers</li>
          <li><strong>Mobile:</strong> mobile-first UI patterns (optimized reading + quick actions)</li>
        </ul>

        <h3>Target Users</h3>
        <p>
          The target audience includes <strong>Christians</strong> and <strong>seekers</strong> who want a lightweight tool
          for daily Scripture reading, prayer writing, and optional community interaction.
        </p>

        <h3>Core Features</h3>
        <ul style={{ textAlign: 'left' }}>
          <li><strong>Verse search</strong> (supports Chinese/English content search)</li>
          <li><strong>Prayer creation</strong> with related Scripture references</li>
          <li><strong>Public prayer wall</strong> + personal prayer list</li>
          <li><strong>Likes & comments</strong> to encourage community support</li>
          <li><strong>User accounts</strong>: login/register, profile, avatar upload, language preference</li>
          <li><strong>Friends</strong>: search users, send/accept requests, view public profiles</li>
        </ul>

        <h3>Information Architecture / Site Map</h3>
        <img src={SiteMap} alt="WithElim Site Map" width="80%" style={{ borderRadius: '2rem' }} />
        <br /><br />
        <p><strong>Main sections:</strong></p>
        <p>1. Home / Bible reading & verse navigation</p>
        <p>2. Verse Search / jump to verse context</p>
        <p>3. Prayer: Public Wall / My Prayers / Create & Edit</p>
        <p>4. Community: Friends / User Profiles</p>
        <p>5. Account: Settings / language / avatar</p>

        <br />
        <h3>Mobile-first UX (Reading + Quick Actions)</h3>
        <p>
          The mobile version focuses on fast access to search, reading context, and prayer actions. Key interactions are
          kept within thumb reach, and content density is reduced for comfortable reading.
        </p>

        <h3>Flutter APP</h3>
         <img src={FlutterApp} alt="Flutter App" width="80%" style={{ borderRadius: '2rem' }} />
         <p>
          The app allows users to read Scripture, search verses, and create prayers linked to specific passages, while offering optional sharing, likes, and comments to encourage mutual support.

Built with a mobile-first mindset, the Flutter app focuses on clarity, readability, and smooth interaction, providing a calm and consistent spiritual experience across both iOS and Android devices.
        </p>
        <img src={HiFiPrototype} alt="HiFi Prototype" width="80%" style={{ borderRadius: '2rem' }} />
        <br /><br />

        <h3>Design Decisions</h3>
        <br />

        <h4>Brand / Logo</h4>
        <p>
          <img
            src={WithElimLogo}
            alt="WithElim Logo"
            width="40%"
            style={{ borderRadius: '2rem', display: 'inline-block' }}
          />
          The logo area also works as a consistent “home” entry point to support quick navigation and reduce user friction.
        </p>

        <h4>Navigation</h4>
        <img src={WithElimNav} alt="WithElim Navigation" width="80%" style={{ borderRadius: '2rem' }} />
        <p>
          Navigation is designed to reflect the user's natural journey: <strong>Read → Search → Pray → Connect</strong>.
          The UI keeps actions simple and emphasizes clarity to support long-form reading.
        </p>

        <br />
        <img src={WithElimDisplay} alt="WithElim Display" width="80%" style={{ borderRadius: '1rem' }} />
        <br /><br />

        <p>
          The design follows <strong>“Aesthetic and minimalist design”</strong> — a calm layout, readable typography,
          and clean visual structure to keep the focus on Scripture and prayer content.
        </p>
 <h4>Prayer</h4>
 
 <div
  style={{
    display: "flex",
    alignItems: "center", // ✅ 垂直居中，保证高度一致
    gap: "1.5rem",        // 图片和文字间距
    margin: "1.5rem 0",
  }}
>
  <img
    src={PrayerCard}
    alt="WithElim Prayer Card"
    style={{
      width: "20%",
      borderRadius: "1rem",
      flexShrink: 0,      // 防止被压缩
    }}
  />

  <p style={{ margin: 0 }}>
    <strong>PrayerCard</strong> is the core interactive unit of the WithElim platform,
    designed to present individual prayers in a clear and contemplative format.
    Each card displays a prayer’s content, author, creation time, and linked Bible verses,
    while supporting key interactions such as praying (liking), commenting, editing,
    and privacy control.
    <br /><br />
    It enables users to engage with prayers both personally and communally,
    balancing spiritual reflection with lightweight social interaction across
    desktop and mobile experiences.
  </p>
</div>
        <br />
        <h3>Implementation</h3>
        <p>
          WithElim is built as a full-stack project with a responsive front end and an API-driven backend. The system
          supports authentication, multilingual content handling, and community interactions such as comments, likes,
          and friend relationships.
        </p>

        <br />
      </div>

      {isVisible && isScrolling && (
        <div className={Styles.SwitcherContainer}>
          <button
            className={Styles.SwitcherButton}
            onClick={() => {
              handleScrollToTop();
              SwitcherOnClick("left");
            }}
          >
            {"<"}
          </button>
          <button
            className={Styles.SwitcherButton}
            onClick={() => {
              handleScrollToTop();
              SwitcherOnClick("right");
            }}
          >
            {">"}
          </button>
        </div>
      )}
    </div>
  );
}

export default WithElimWeb;
